import React from 'react';
import useScrollAnimation from './UseScrollAnimation';
import { useNavigate } from 'react-router-dom';

const Assistencia = () => {
  useScrollAnimation();
  const navigate = useNavigate();

  return (
    // py-16 no mobile e py-24 no desktop
    <section className="bg-[#00111f] py-16 md:py-24 text-white overflow-hidden reveal">
      {/* px-4 no mobile para ganhar espaço */}
      <div className="container mx-auto px-4 sm:px-6 md:px-12">
        {/* gap-10 no mobile e gap-16 no desktop */}
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          
          {/* Text Content */}
          <div className="flex-1 lg:pr-8 w-full">
            
            <div className="flex items-center gap-4 mb-5 md:mb-6">
              <span className="w-12 h-[3px] bg-usifresa-orange"></span>
              <span className="text-xs md:text-sm font-black text-usifresa-light-blue uppercase tracking-[0.3em]">
                Suporte
              </span>
            </div>
            
            {/* Título text-3xl no mobile */}
            <h2 className="text-3xl md:text-5xl font-sans font-black leading-tight mb-6 md:mb-8">
              Assistência técnica e<br className="hidden md:block" />suporte da Usifresa
            </h2>
            
            {/* Texto text-base no mobile */}
            <div className="text-gray-300 text-base md:text-lg leading-relaxed space-y-6">
              <p>
                A Usifresa dispõe de uma assistência técnica eficaz, com grande estoque de peças de reposição, uma loja virtual onde o cliente pode fazer seus pedidos de peças e uma central telefônica para solicitar um técnico, tirar dúvidas e executar reparos nos equipamentos.
              </p>
              
              {/* Caixa de lista com padding reduzido no mobile (p-5) */}
              <div className="bg-white/5 rounded-2xl p-5 md:p-8 backdrop-blur-sm border border-white/10 mt-6 md:mt-8">
                <p className="text-white font-medium mb-5 md:mb-6">A Usifresa dispõe também de um trabalho de campo:</p>
                <ul className="space-y-4 font-semibold text-white/90 text-sm md:text-base">
                  <li className="flex items-start gap-3 md:gap-4">
                    <div className="bg-usifresa-orange/20 p-1.5 rounded-full mt-0.5 shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 md:w-5 md:h-5 text-usifresa-orange" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z"/>
                      </svg>
                    </div>
                    <span>Fazendo instalações de máquinas.</span>
                  </li>
                  <li className="flex items-start gap-3 md:gap-4">
                    <div className="bg-usifresa-orange/20 p-1.5 rounded-full mt-0.5 shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 md:w-5 md:h-5 text-usifresa-orange" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z"/>
                      </svg>
                    </div>
                    <span>Manutenção técnica especializada.</span>
                  </li>
                  <li className="flex items-start gap-3 md:gap-4">
                    <div className="bg-usifresa-orange/20 p-1.5 rounded-full mt-0.5 shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 md:w-5 md:h-5 text-usifresa-orange" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z"/>
                      </svg>
                    </div>
                    <span>Treinamento de manutenção preventiva e corretiva.</span>
                  </li>
                  <li className="flex items-start gap-3 md:gap-4">
                    <div className="bg-usifresa-orange/20 p-1.5 rounded-full mt-0.5 shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 md:w-5 md:h-5 text-usifresa-orange" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z"/>
                      </svg>
                    </div>
                    <span>Técnicas de produção avançadas.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Image & CTA */}
          <div className="flex-1 w-full">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
              {/* h-400 no mobile para não ficar muito esticado */}
              <img 
                src="/fabrica-usifresa2.jpeg" 
                alt="Assistência técnica e suporte da Usifresa" 
                className="w-full h-[400px] md:h-[500px] object-cover group-hover:scale-105 transition-transform duration-700" 
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#082c4c] via-[#082c4c]/40 to-transparent opacity-90"></div>
              
              {/* px-6 para o botão não bater na borda da imagem no celular */}
              <div className="absolute bottom-6 md:bottom-8 left-0 right-0 px-6 flex justify-center">
                <button 
                  onClick={() => navigate('/contato')}
                  className="w-full sm:w-auto px-8 py-3.5 md:py-3 bg-usifresa-orange hover:bg-orange-600 text-white font-bold rounded-full shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 uppercase tracking-widest text-sm"
                >
                  Saiba mais
                </button>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default Assistencia;